import React, { CSSProperties, ReactElement } from 'react'

import Icon from '../../atoms/Icon'

const renderIcon = (props: {
  boldText?: string | undefined
  iconColor: any
  iconName: any
  iconPosition: any
  iconSize: any
  iconStyle: any
  onPress?: (() => void) | undefined
  renderCustomIcon: any
  renderCustomText?:
    | (() => React.ReactElement<any, string | React.JSXElementConstructor<any>>)
    | undefined
  style?: React.CSSProperties | undefined
  text?: string | undefined
  textColor?: string | undefined
}) => {
  const {
    iconName,
    iconColor,
    iconPosition = 'left',
    iconSize = 20,
    iconStyle,
    renderCustomIcon,
  } = props

  const iconStyles =
    iconPosition === 'left'
      ? { marginRight: 10, height: iconSize, ...iconStyle }
      : { marginLeft: 10, height: iconSize, ...iconStyle }

  if (renderCustomIcon) return renderCustomIcon()

  return (
    <div style={iconStyles}>
      <Icon color={iconColor} name={iconName} size={iconSize} />
    </div>
  )
}

const renderText = (props: {
  boldText: any
  iconColor?: string | undefined
  iconName?: string | undefined
  iconPosition?: string | undefined
  iconSize?: number | undefined
  iconStyle?: object | undefined
  onPress?: (() => void) | undefined
  renderCustomIcon?: (() => void) | undefined
  renderCustomText: any
  style?: React.CSSProperties | undefined
  text: any
  textColor: any
}) => {
  const { boldText, renderCustomText, text, textColor } = props

  if (renderCustomText) return renderCustomText()

  return (
    <div>
      {(boldText || boldText === 0) && (
        <span style={{ ...styles.boldText, color: textColor }}>
          {`${boldText} `}
        </span>
      )}
      <span style={{ color: textColor }}>{text}</span>
    </div>
  )
}

export type Props = {
  boldText?: string
  iconColor?: string
  iconName?: string
  iconPosition?: string
  iconSize?: number
  iconStyle?: object
  onPress?: () => void
  renderCustomIcon?: () => void
  renderCustomText?: () => ReactElement
  style?: CSSProperties
  text?: string
  textColor?: string
}

/**
@description Renders an icon and renderCustomText

@param {string} boldText. Bold text to be displayed. Can be empty.

@param {string} iconColor. The colour of the icon.

@param {string} iconName. The icon name. See Icon for valid
icon names.

@param {string} iconPosition. Sets the icon position relative
to the text. Can be either left or right. Is left by default.

@param {number} iconSize. Sets the size of the icon.

@param {object} iconStyle. Sets the style of the icon.

@param {function} onPress. Fires when component is clicked.

@param {function} renderCustomIcon. Render function. Allows customised
icons to be rendered.

@param {function} renderCustomText. Render function. Allows custom text to be rendered.

@param {object} style. Style object. Allows custom styling of LabelIcon

@param {string} text. Normal text to be displayed

@param {string} textColor. Colour of the text/bold text. Can be left blank.

@returns {function} LabelIcon.
*/

export default function LabelIcon(props: Props) {
  const {
    iconName,
    iconPosition = 'left',
    onPress,
    renderCustomIcon,
    renderCustomText,
    style,
    text,
  } = props

  const wrapperStyles = {
    ...styles.wrapper,
    ...(!!onPress && { cursor: 'pointer' }),
    ...style,
  }

  return (
    <div onClick={onPress} style={wrapperStyles}>
      {iconPosition === 'left' &&
        (iconName || renderCustomIcon) &&
        // @ts-ignore
        renderIcon(props)}
      {/* @ts-ignore */}
      {(text || renderCustomText) && renderText(props)}
      {iconPosition === 'right' &&
        (iconName || renderCustomIcon) &&
        // @ts-ignore
        renderIcon(props)}
    </div>
  )
}

const styles = {
  boldText: {
    fontWeight: 700,
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
  },
}
